import { Button } from '@/components/ui/button'
import { MouseEventHandler } from 'react'

export interface IButtonTableHeader {
  type: 'button'
  onClick: MouseEventHandler<HTMLButtonElement>
  label: string
  icon?: React.ReactNode
}
type Props = Omit<IButtonTableHeader, 'type'>
export function ButtonTableHeader({ onClick, label, icon }: Props) {
  return (
    <Button
      className="h-8 w-full gap-1"
      onClick={onClick}
      size="sm"
      variant="outline"
    >
      {icon}
      <span>{label}</span>
    </Button>
  )
}
